import { apiConfig } from '../../../utils/apiConfig';
import { DataPresetAPI } from './PresetsAPI';

export function usePresetsAPI(): DataPresetAPI {
  return new DataPresetAPI(apiConfig);
}
